import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import { faMessage, faEnvelope } from '@fortawesome/free-regular-svg-icons';

import verificationBGImage from '../../assets/images/amazon/verificationBGImage.png';
import TenantConfig from '../../config';
import { truncateEmail } from '../../helpers/format';
import MerchantPortalFooter from '../common/MerchantPortalFooter';

const SelectChannel = ({ onSubmit, email, phone, channels, className }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedChannel, setSelectedChannel] = useState('');
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    if (!phone || phone === '+1-___-___-____') {
      navigate('/auth/sign-in');
    }
  }, [location, phone]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedChannel == '') {
      setSubmitError('Please select the channel.');
    }
    await onSubmit({ channel: selectedChannel });
    console.log('success');
    navigate('/auth/phone-verification' + location.search);
  };

  return (
    <div className={`${className}-phone`}>
      {className === 'admin' && <img className="logo" src={TenantConfig.headerLogo} alt="logo" />}
      <div
        className={`${className} section phone-verification ${
          className !== 'admin' ? 'phone-verification-full' : ''
        }`}
      >
        <div
          className={className === 'admin' ? `${className}-phone-header` : `${className}-header`}
        >
          <h1>We want to send you a code</h1>
        </div>
        <div className="subtitle">
          <p>Please select where you would like to receive the verification code:</p>
        </div>
        <form onSubmit={handleSubmit} className="form select-channel">
          {channels.map((channel) => {
            return (
              <div className="custom-radio-button" key={channel}>
                <label htmlFor={`custom-radio-${channel}`}>
                  <input
                    type="radio"
                    checked={selectedChannel === channel}
                    id={`custom-radio-${channel}`}
                    name="opt-channel"
                    onChange={() => setSelectedChannel(channel)}
                    spellCheck={false}
                  />
                  {channel == 'EMAIL' && (
                    <span>
                      <FontAwesomeIcon fontSize={20} icon={faEnvelope} /> email:{' '}
                      {truncateEmail(email)}
                    </span>
                  )}
                  {channel == 'PHONE_SMS' && (
                    <span>
                      <FontAwesomeIcon fontSize={20} icon={faMessage} /> SMS: *******{phone}
                    </span>
                  )}
                </label>
              </div>
            );
          })}
          <div className="submit-wrapper">
            <button className="btn primary-btn" type="submit" disabled={selectedChannel === ''}>
              Confirm
            </button>
          </div>
          {submitError && <p className="error-text">{submitError}</p>}
        </form>
        <p className="subtitle">
          <small>
            <Link to={`/auth/sign-in${location.search}`}>Already registered? Sign in!</Link>
          </small>
        </p>
      </div>
      {TenantConfig?.auth.renderBottomImg && className !== 'admin' && (
        <img
          className="phone-verification-bg"
          src={verificationBGImage}
          alt="Verification Background Image"
        />
      )}
      {className === 'admin' && <MerchantPortalFooter />}
    </div>
  );
};

export default SelectChannel;
